<div class="pnl-customer">
    <header>
        <div>
          <button (click)="onBack()" class="btn btn-primary-outline">Voltar</button>
          <button (click)="onCancelRegister()" [disabled]="customer.idusuario==0" class="btn btn-primary-outline">Cancelar</button>
          <button (click)="onSubmit()" class="btn btn-primary" [disabled]="!changeDetail">Salvar</button>
        </div>
    </header>

    <form [formGroup]="customerFrm" (ngSubmit)="onSubmit()" novalidate>
      <section class="pnl pnl-step-one">
        <h3>Cadastro de cliente</h3>
        <nav>
          <a (click)="onTabClick('dados')" [class.active]="tab == 'dados'">Dados pessoais</a>
          <a (click)="onTabClick('endereco')" [class.active]="tab == 'endereco'">Endereço</a>
        </nav>
        <div class="tab-dados" [class.dnone]="tab != 'dados'">
            <div>
                <div>
                    <label>Nome do cliente</label>
                    <input type="text" class="form-control" (keyup)="onChangeDetail()" formControlName="nome" />
                </div>
                <div>
                    <label>Telefone</label>
                    <input type="text" class="form-control" [mask]="m_telefone" (keyup)="telefonemask($event)" formControlName="telefone" />
                </div>
            </div>
            <div>
                <div>
                    <label>CPF / CNPJ</label>
                    <input type="text" class="form-control" [mask]="m_cpf_cnpj" (keyup)="cpfcnpjmask($event)" formControlName="cpf" />
                </div>
                <div>
                    <label>E-mail</label>
                    <input type="email" class="form-control" (keyup)="onChangeDetail()" formControlName="email" />
                </div>
            </div>
        </div>

        <div class="tab-endereco" [class.dnone]="tab != 'endereco'">
            <div formArrayName="enderecos">
                <div class="endereco" *ngFor="let endereco of enderecos.controls; let i=index" [formGroupName]="i">
                    <div>
                        <div class="col-1">
                            <label>CEP</label>
                            <input type="text" class="form-control" formControlName="cep" (keyup)="onCEPChange(i)" mask="00000-000" placeholder="00000-000" />
                        </div>
                        <div class="col-2"></div>
                        <div class="col-3"></div>
                    </div>
                    <div>
                        <div class="col-1">
                            <label>Logradouro</label>
                            <input type="text" class="form-control" formControlName="logradouro" (keyup)="onChangeDetail()" />
                        </div>
                        <div class="col-2">
                            <label>Número</label>
                            <input type="text" class="form-control" formControlName="numero" (keyup)="onChangeDetail()" />
                        </div>
                        <div class="col-3">
                            <label>Complemento</label>
                            <input type="text" class="form-control" formControlName="complemento" (keyup)="onChangeDetail()" />
                        </div>
                    </div>
                    <div>
                        <div class="col-1">
                            <label>Bairro</label>
                            <input type="text" class="form-control" formControlName="bairro" [attr.disabled]="'disabled'" />
                        </div>
                        <div class="col-2">
                            <label>Estado</label>
                            <input type="text" class="form-control" formControlName="uf" [attr.disabled]="'disabled'" />
                        </div>
                        <div class="col-3">
                            <label>Cidade</label>
                            <input type="text" class="form-control" formControlName="cidade" [attr.disabled]="'disabled'" />
                        </div>
                    </div>

                    <button (click)="deleteAddress(i)" type="button" class="btn btn-danger-outline">Excluir</button>
                </div>

                <div *ngIf="customer.edita" class="actions">
                  <button (click)="addAddress()" type="button" class="btn btn-primary">Adicionar novo endereço</button>
                </div>
            </div>
        </div>
      </section>
    </form>

    <div class="loading" *ngIf="loading">
      <div class="loadingio-spinner-eclipse-cz3y1wre1nd">
        <div class="ldio-ns36390yc">
          <div></div>
        </div>
      </div>
    </div>
  </div>

  <div class="pnl-find-cep" *ngIf="loadingCEP">
    <div class="loading">
        <h1>Procurando o CEP...</h1>
        <div class="loadingio-spinner-eclipse-cz3y1wre1nd">
            <div class="ldio-ns36390yc">
                <div></div>
            </div>
        </div>
    </div>
  </div>
